import { message } from 'antd';

export const handleAuthError = (error: any) => {
  if (error.response?.status === 401 || error.response?.status === 403) {
    localStorage.removeItem('token');
    message.error('Your session has expired. Please log in again.');
    window.location.href = '/login';
  } else {
    message.error('An error occurred. Please try again.');
  }
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token: string) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
}; 